'use client'

import Image from 'next/image'
import Link from 'next/link'
import type { CourseType } from '@/types/course-type'
import { Button } from '@/components/ui/button'
import starIcon from '@/public/icons/star.svg'

interface FeaturedCourseProductProps {
  product: CourseType
}

function getDestinationRoute(
  productType: string,
  externalId: string | null,
  publicUrl: string
): string {
  switch (productType) {
    case 'course':
      return `/cursos/info/${externalId}/${publicUrl}`
    case 'mentorship':
      return `/cursos/info/${externalId}/${publicUrl}`
    case 'personalized':
      return `/cursos/info/${externalId}/${publicUrl}`
    case 'postgraduate':
      return `/pos-graduacoes/info/${externalId}/${publicUrl}`
    default:
      return `/cursos/trilha/${publicUrl}`
  }
}

function courseType(productType: string) {
  switch (productType) {
    case 'postgraduate':
      return 'Pós graduação'
    case 'track':
      return 'Trilha'
    default:
      return 'Curso online'
  }
}

export default function FeaturedProductCard({
  product,
}: FeaturedCourseProductProps) {
  return (
    <Link
      className="group w-full md:max-w-[17.6rem]"
      href={getDestinationRoute(
        product?.product_type,
        product?.external_id,
        product?.public_url
      )}
    >
      <div className="flex flex-wrap items-center justify-between">
        <div>
          <span className="flex items-center gap-1 text-[#404040] text-sm">
            <Image
              alt="Ícone de estrela"
              height={24}
              src={starIcon}
              width={24}
            />
            Curso Destaque:{' '}
            <span className="font-medium text-[#171717] text-lg lg:text-2.5xl">
              {product?.name}
            </span>
          </span>
        </div>

        <div className="w-full rounded-1xl border border-[#E3C3FF] bg-[#E3C3FF99] text-center text-[#171717] text-sm lg:w-56">
          TEA e Proposta de Intervenção
        </div>
      </div>

      <div className="mt-4 flex w-full flex-wrap items-start gap-4 lg:flex-nowrap">
        <div className="relative w-full">
          <span className="absolute top-2 left-4 z-10 rounded bg-[#EAEEFD] p-1 font-medium text-gray-950 text-xs">
            {courseType(product?.product_type)}
          </span>
          <div className="overflow-hidden rounded-lg">
            <Image
              alt=""
              className="h-[11.4rem] min-w-full scale-100 rounded-lg object-cover filter transition duration-700 group-hover:scale-125 group-hover:brightness-50 lg:min-w-97.75"
              height={180}
              src={product?.image_url ?? ''}
              width={280}
            />
          </div>
        </div>
        <div className="mt-2 w-full">
          <div className="w-full space-y-2 lg:max-w-97.75">
            <h3 className="line-clamp-1 font-bold text-base text-gray-900 leading-5">
              {product?.name}
            </h3>
            <p className="line-clamp-3 font-normal text-gray-500 text-sm leading-[17px]">
              {product?.description}
            </p>
          </div>
          <div className="mt-2">
            <div className="flex items-center justify-between border-primary-100 border-b pb-3">
              <div className="flex items-center">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Image
                    alt="Ícone de estrela"
                    height={16}
                    key={i}
                    src={starIcon}
                    width={16}
                  />
                ))}
              </div>
              {/* {product_type && product_type !== 'track' &&
                <div className="flex items-center gap-1">
                  <Clock className="size-4 text-gray-50" fill="#8B98D1" />
                  <span className="text-sm font-normal text-gray-900">
                    {workloads && workloads.length > 1 ?
                      `${course.workloads[0].workload_value} à ${course.workloads[course.workloads.length - 1].workload_value} Horas`
                      : `${course.workloads[0].workload_value} Horas`}
                  </span>
                </div>
              } */}
            </div>
            <div className="mt-3">
              <Button className="min-h-10 text-sm">
                Fazer inscrição
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Link>
  )
}
